$(document).ready(function () {
  const MAX_VISIBLE_DOTS = 5;

  function updatePagingInfo(slick, currentSlide) {
    const $dots = slick.$slider.find(".slick-dots li");
    const activeIndex = $dots.filter(".slick-active").index();
    const total = $dots.length;
    const progress = total > 0 ? ((activeIndex + 1) / total) * 100 : 0;

    // Update numeric info in either container (some themes vary)
    slick.$slider.closest(".tab-content").find(".pagingInfo").text(`${activeIndex + 1}/${total}`);
    slick.$slider.closest(".tab-contents").find(".pagingInfo").text(`${activeIndex + 1}/${total}`);

    // Progress bar
    const $bar = slick.$slider.closest(".tab-content").find(".slider-progress .progress-bar");
    if ($bar.length) $bar.css("width", `${progress}%`);
  }

  function limitVisibleDots(slick) {
    if (!slick.$dots) return;
    const $dots = slick.$dots.find("li");
    const totalDots = $dots.length;
    const activeIndex = $dots.filter(".slick-active").index();

    let start = Math.max(0, activeIndex - Math.floor(MAX_VISIBLE_DOTS / 2));
    let end = Math.min(totalDots, start + MAX_VISIBLE_DOTS);
    if (end - start < MAX_VISIBLE_DOTS) start = Math.max(0, end - MAX_VISIBLE_DOTS);

    $dots.hide().slice(start, end).show();
  }

  // ----- init: one slider per tab-content -----
  $(".new-arrival-sec .tab-content").each(function () {
    const $wrap   = $(this);                                      // the active tab-content container
    const $slider = $wrap.find(".new-arrival-sec-pro-slider");    // the slider inside it

    if (!$slider.length) return;

    // Bind events before init (scoped to this slider)
    $slider.on("init reInit", function (event, slick) {
      updatePagingInfo(slick, slick.currentSlide);
      limitVisibleDots(slick);
    });

    $slider.on("afterChange", function (event, slick, currentSlide) {
      updatePagingInfo(slick, currentSlide);
      limitVisibleDots(slick);
    });

    // Initialize with THIS tab’s custom arrows
    $slider.slick({
      dots: true,
      infinite: false,
      speed: 300,
      slidesToShow: 4.2,
      slidesToScroll: 3,

      // Use the buttons from the same tab-content
      prevArrow: $wrap.find("button.slick-prev"),
      nextArrow: $wrap.find("button.slick-next"),

      responsive: [
        {
          breakpoint: 1050,
          settings: { slidesToShow: 3.2, slidesToScroll: 1, infinite: false, dots: true }
        },
        { breakpoint: 800, settings: { slidesToShow: 2.5, slidesToScroll: 1 } },
        { breakpoint: 600, settings: { slidesToShow: 1.4, slidesToScroll: 1 } },
        { breakpoint: 480, settings: { slidesToShow: 1.4, slidesToScroll: 1 } }
      ]
    });
  });

  // ----- tab switching (keep your existing behavior, but scope to the active tab) -----
  $(".new-arrival-sec").each(function () {
    const $section = $(this);

    $section.find(".tab").on("click", function (evt) {
      evt.preventDefault();

      // Update tab UI
      $section.find(".tab").removeClass("active");
      $(this).addClass("active");

      $section.find(".tab-content").removeClass("active");
      const targetSelector = $(this).data("toggles-target");
      const $targetContent = $section.find(targetSelector);
      $targetContent.addClass("active");
      $targetContent.find(".new-arrival-sec-pro-item").css("opacity", 0);

      // Only touch the slider inside the activated tab
      const $slider = $targetContent.find(".new-arrival-sec-pro-slider");

      // Go to first slide and refresh paging
      if ($slider.length && $slider.hasClass("slick-initialized")) {
        $slider.slick("slickGoTo", 0, true); // jump w/o animation
        setTimeout(function () {
          $targetContent.find(".new-arrival-sec-pro-item").css("opacity", 1);
        }, 300);

        const slickInstance = $slider.slick("getSlick");
        updatePagingInfo(slickInstance, 0);
        limitVisibleDots(slickInstance);
      }
    });
  });

  // Show first tab on page load
  $(".new-arrival-sec").each(function () {
    $(this).find(".tab").first().trigger("click");
  });

  // Prevent clicks on disabled arrows from bubbling
  $("body").on("click", ".slick-arrow.slick-disabled", function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
  });
});
